export const CLOSE_EMAIL_NOTIFICATIONS_PROMPT =
  'pageSegments/emailNotifications/CLOSE_PUSH_NOTIFICATIONS_PROMPT';
